export default "__VITE_ASSET__Bnky95cQ__"